// extracted by mini-css-extract-plugin
module.exports = {"root":"IconDown_root__3gOSK"};